import ContentEditable from "react-contenteditable";
import style from "./Time.module.css";
import { ref, update } from "firebase/database";
import { db } from "../../../configs/Firebase";
import sanitizeHTML from "sanitize-html";
import { useEffect, useState } from "react";
import Icon from "../../../designSystem/a-atoms/icons/Icon";

const Time = (props) => {
  const [hasRendered, setHasRendered] = useState(false);
  const [cellVal, setCellVal] = useState("");
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    setCellVal(props.data.value);
    setHasRendered(true);

    let val = parseInt(props.data.value);
    if (val < 60) {
      setSeconds(val);
    } else {
      let mins = Math.floor(val / 60);
      if (mins > 59) {
        let tempHours = Math.floor(mins / 60);
        setHours(tempHours);
        setMinutes(mins - tempHours * 60);
        setSeconds(val - (mins - tempHours * 60) * 60 - tempHours * 60 * 60);
      } else {
        setMinutes(mins);
        setSeconds(val - mins * 60);
      }
    }
  }, [props.data.value]);

  // function onChangeHandler(e, columnId) {
  //   update(ref(db), {
  //     [props.journeyRefURL +
  //     "/rows/" +
  //     props.row.id +
  //     "/columns/" +
  //     columnId +
  //     "/value"]: sanitizeHTML(e.target.value),
  //   });
  //   setCellVal(e.target.value);
  // }

  function onHoursChangeHandler(e, columnId) {
    if (parseInt(e.target.value) >= 0) {
      let tempTime =
        parseInt(e.target.value) * 60 * 60 + minutes * 60 + seconds;
      update(ref(db), {
        [props.journeyRefURL +
        "/rows/" +
        props.row.id +
        "/columns/" +
        columnId +
        "/value"]: sanitizeHTML(tempTime),
      });
      setCellVal(tempTime);
    }
  }

  function onMinutesChangeHandler(e, columnId) {
    if (parseInt(e.target.value) >= 0) {
      let tempTime = hours * 60 * 60 + parseInt(e.target.value) * 60 + seconds;
      update(ref(db), {
        [props.journeyRefURL +
        "/rows/" +
        props.row.id +
        "/columns/" +
        columnId +
        "/value"]: sanitizeHTML(tempTime),
      });
      setCellVal(tempTime);
    }
  }

  function onSecondsChangeHandler(e, columnId) {
    if (parseInt(e.target.value) >= 0) {
      let tempTime = hours * 60 * 60 + minutes * 60 + parseInt(e.target.value);
      update(ref(db), {
        [props.journeyRefURL +
        "/rows/" +
        props.row.id +
        "/columns/" +
        columnId +
        "/value"]: sanitizeHTML(tempTime),
      });
      setCellVal(tempTime);
    }
  }

  function selectAll(e) {
    var range, selection;
    if (document.body.createTextRange) {
      range = document.body.createTextRange();
      range.moveToElementText(e.currentTarget);
      range.select();
    } else if (window.getSelection) {
      selection = window.getSelection();
      range = document.createRange();
      range.selectNodeContents(e.currentTarget);
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }

  return (
    <div className={`${style.cell} ${props.editable ? style.editable : null}`}>
      {props.editable ? (
        <>
          <ContentEditable
            html={"" + hours}
            onChange={(e) => onHoursChangeHandler(e, props.cellIndex)}
            inputMode="number"
            onFocus={(e) => selectAll(e)}
          />
          :
          <ContentEditable
            html={"" + minutes}
            onChange={(e) => onMinutesChangeHandler(e, props.cellIndex)}
            inputMode="number"
            onFocus={(e) => selectAll(e)}
          />
          :
          <ContentEditable
            html={"" + seconds}
            onChange={(e) => onSecondsChangeHandler(e, props.cellIndex)}
            inputMode="number"
            onFocus={(e) => selectAll(e)}
          />
        </>
      ) : (
        <div><Icon>timer</Icon>
          {hours > 0 && hours + ":"}
          {minutes.toString().padStart(2, "0")}:
          {seconds.toString().padStart(2, "0")}
        </div>
      )}
    </div>
  );
};

export default Time;
